import cn from "classnames";
import type { ChatChannel } from "../types";

interface ChatSidebarItemProps {
  channel: ChatChannel;
  isActive: boolean;
  onClick: (id: number) => void;
}

export default function ChatSidebarItem({ channel, isActive, onClick }: ChatSidebarItemProps) {
  function handleClick() {
    onClick(channel.id);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        "flex items-center gap-3 px-3 py-2.5 w-full radius-md transition-colors text-left cursor-pointer",
        isActive ? "bg-brand-200" : "hover:surface-secondary-fill",
      )}>
      <div className="w-10 h-10 radius-sm surface-brand-subtle flex items-center justify-center shrink-0">
        <span className="text-body-bold-md content-action-brand">{channel.display_name.charAt(0).toUpperCase()}</span>
      </div>
      <span
        className={cn(
          "truncate",
          isActive ? "text-body-bold-lg content-base-primary" : "text-body-regular-lg content-base-primary",
        )}>
        {channel.display_name}
      </span>
    </button>
  );
}
